export const HOME_PAGE_ARTICLE = {
  header: "A simple solution to complex tasks is coming soon",
  body:
    "Say goodbye to inefficient juggling of multiple apps, teams, and projects.Officelite is the new collaboration platform built with an intuitive interface to improve productivity.",
};

export const SIGNUP_PAGE_ARTICLE = {
  header: "Work smarter. Save time.",
  body:
    "Easily manage your projects. Get on the list and receive in-app perks available only to early subscribers. We are moving into final development and getting ready for official launch soon.",
};
